import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { listingsApi as n } from "@maat/api-main";
//#region src/properties/useListingPreviewQuery.ts
var r = (r) => t({
	queryKey: e.listing(r),
	queryFn: () => n.getListingDetail(r),
	enabled: !!r
});
//#endregion
export { r as useListingPreviewQuery };
